import { COOKIE_DOMAIN, TPLTS } from '../../constants/constants';
import WpAPI from '../../WpApi';
import { v4 as uuidv4 } from 'uuid';
import { getDateTime } from '../../helper';
import Cookies from 'js-cookie';
import initialData from '../../initial-data';
export const HEADING = 'HEADING';
export const EDIT_INPUTBOX = 'EDIT_INPUTBOX';
export const BACK_BUTTON = 'BACK_BUTTON';
export const SAVE_RESUME = 'SAVE_RESUME';
export const GOTO_PAGE = 'GOTO_PAGE';
export const SIGNUP = 'SIGNUP'
export const SET_LOGIN_HASH = 'SET_LOGIN_HASH'
export const SET_INITIAL_DATA = 'SET_INITIAL_DATA'
export const ONNEXT_CLICK = 'ONNEXT_CLICK'
export const NUTERALIZE_NEXT_CLICK = 'NUTERALIZE_NEXT_CLICK'
export const ONBACK_CLICK = 'ONBACK_CLICK'
export const NUTERALIZE_BACK_CLICK = 'NUTERALIZE_BACK_CLICK'
export const PREVIEW_RESUME = 'PREVIEW_RESUME'
export const WITHOUT_MERGE = 'WITHOUT_MERGE'
export const ONSKIP_CLICK = 'ONSKIP_CLICK'
export const STORE_VERSION = 'STORE_VERSION'
export const UPDATE_REDUCER = 'UPDATE_REDUCER'
export const UPDATE_RB_SECTION_COMPLETENESS = 'UPDATE_RB_SECTION_COMPLETENESS'
export const SET_DOWNLOAD_FORMAT = 'SET_DOWNLOAD_FORMAT'
export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_MEMBERSHIP_DATA = 'SET_MEMBERSHIP_DATA'
export const SET_CONTEXT_MENU = 'SET_CONTEXT_MENU'
export const COVERLETTER_UPDATE = 'COVERLETTER_UPDATE'
export const INITIALIZE_COVER_LETTER = 'INITIALIZE_COVER_LETTER'
export const setInitialData = (loginHash, currentResume, resume, user) => {
    const action_data = {
        type: SET_INITIAL_DATA,
    }
    if (loginHash){
        action_data['loginHash'] = loginHash
    }
    if (currentResume){
        action_data['currentResume'] = currentResume
    }
    if (resume){
        action_data['resume'] = resume
    }
    if (user){
        action_data['user'] = user
    }

    return action_data;
};



export const onInputBoxEdit = (value) => {
    //console.log('Input Value:', value);
    return ({
        type: EDIT_INPUTBOX,
        payload: value
    });
};

export const onButtonClick = (value) => {
    //console.log('This is back button click event');
    return ({
        type: BACK_BUTTON,
        payload: value
    });
};

export const gotoURL = (data) => {
    //console.log('Action gotoPage', data);
    return ({
        type: GOTO_PAGE,
        payload: data
    });
};

export const onNextClick = () => {
    return ({
        type: ONNEXT_CLICK,
        payload: { next_clicked: true }
    });
}

export const nuteralizeNextClick = (next_label, saveit, nextModule) => {
    return function (dispatch, getState) {
        let payload
        const { resume } = getState()
        saveit && resume.hasOwnProperty('modified_date') && (resume.modified_date = getDateTime())
        nextModule && (resume.enabled_tabs = Array.from(new Set([...resume.enabled_tabs, nextModule])))
        payload = {
            next_clicked: false,
            skip_clicked: false,
            ...next_label,
            resume
        }
        Promise.resolve(dispatch(
            ({
                type: ONNEXT_CLICK,
                payload
            })
        )).then(() => {
            // debugger
            //All good
            saveit && WpAPI.saveState(getState(), saveit)
            //Save for preview also in development
            // WpAPI.saveState(getState())
        })
    }
    // return ({
    //     type: ONNEXT_CLICK,
    //     next_clicked: false,
    //     ...next_label

    // })
}

export const onBackClick = () => {
    return ({
        type: ONBACK_CLICK,
        back_clicked: true
    });
}

export const nuteralizeBackClick = (next_label) => {
    return ({
        type: ONBACK_CLICK,
        back_clicked: false,
        ...next_label

    })
}

export const onSkipClick = () => {
    return ({
        type: ONSKIP_CLICK,
        skip_clicked: true,
        next_clicked: true
    });
}

export const saveResume = (details, step, forcesave = false, assignResumeToCurrentId = true) => {
    return function (dispatch, getState) {
        Promise.resolve(dispatch(
            ({
                type: step,
                payload: details
            })
        )).then(() => {
            // debugger
            (step == SAVE_RESUME || forcesave) && WpAPI.saveState(getState(), true, assignResumeToCurrentId)
            //Save for preview also in development
            // WpAPI.saveState(getState())
        })
    };
}
export const saveCoverLetter = (details, saveit = false) => {
    return function (dispatch, getState) {
        Promise.resolve(dispatch(
            ({
                type: COVERLETTER_UPDATE,
                payload: {...details}
            })
        )).then(() => {
            saveit && WpAPI.saveCoverLetter(getState(), true)
        })
    };
}
/*
* saveit false: only save in redux state
* saveit true: only save in redux + localstorage, no db
*/
export const savePreviewCoverLetter = (details, saveit = false) => {
    return function (dispatch, getState) {
        Promise.resolve(dispatch(
            ({
                type: COVERLETTER_UPDATE,
                payload: {...details}
            })
        )).then(() => {
            saveit && WpAPI.saveCoverLetter(getState(), false)
        })
    };
}


export const signUp = (details) => {
    return function (dispatch, getState) {
        return WpAPI.signUp(details.user, details.password, details.confirmpassword, details.token).then(({ loginHash, cookie_name, auth_cookie_name, user }) => {
            dispatch({
                type: SET_LOGIN_HASH,
                loginHash: loginHash,
                user: user
            })
            return { msg: 'success', loginHash: loginHash, cookie_name: cookie_name, auth_cookie_name: auth_cookie_name}

        }).catch((e) => {
            throw (e)
        })

    }
}

export const login = (details) => {
    return function (dispatch, getState) {
        return WpAPI.login(details.user, details.password).then(({loginHash, user}) => {
            dispatch({
                type: SET_LOGIN_HASH,
                loginHash: loginHash,
                user: user
            })
            return { msg: 'success', loginHash: loginHash, user: user}
        })
        .catch((e) => {
            throw (e)
        })
    }
}

export const socialLogin = (user_info, social_login) => {
    return function (dispatch, getState) {
        return WpAPI.socialLogin(user_info, social_login).then((res) => {
            if(res.status === 'ok'){
                dispatch({
                    type: SET_LOGIN_HASH,
                    loginHash: res.loginHash,
                    user: res.user
                })
                return { msg: 'success', loginHash: res.loginHash, user: res.user, account_type: res.account_type}
            }else{
                return { msg: 'error', error: res.error, account_type: res.account_type}
            }
        })
        .catch((e) => {
            throw (e)
        })
    }
}

export const setLoginHash = (loginHash, user = null) => {
    return {
        type: SET_LOGIN_HASH,
        loginHash: loginHash,
        user: user
    }
}

export const uploadResume = (fileupload) => {
    return function (dispatch, getState) {
        console.log('upload started')
        return WpAPI.uploadResume(fileupload).then((resume) => {
            // console.log('resumeeee',resume)
            Cookies.remove('current_resume', { domain: COOKIE_DOMAIN, path: "/" })
            const c = localStorage.getItem('selected_color')
            const t = localStorage.getItem('selected_template')
            const cc = localStorage.getItem('selected_custom_color')
            Cookies.remove('current_resume', { domain: COOKIE_DOMAIN, path: "/" })
            WpAPI.fetchActiveResume(dispatch, ()=>{
                dispatch(saveResume(
                    {
                        ...resume, 
                        active_color: c ? c : 'color-variant-blue',
                        active_template: t ? t : 'template-one',
                        custom_template_color: cc ?? '',
                        created_date: getDateTime(),
                        modified_date: getDateTime()
                    },
                    PREVIEW_RESUME,
                    true))
            })
            localStorage.removeItem('selected_color')
            localStorage.removeItem('selected_template')
            localStorage.removeItem('selected_custom_color')
        }).then((resp => {
            // dispatch(saveResume(resp, PREVIEW_RESUME, true))
            // Cookies.set('rbuser', action.loginHash);
            // console.log('redirect here')
            return { msg: 'success' }
        })).catch((e) => {
            throw (e)
        })
    }
}

export const uploadProfileImage = (fileupload) => {
    return function (dispatch, getState) {
        console.log('image upload started..!!')
        return WpAPI.uploadPicture(fileupload).then((res) => {
            const { resume } = getState();
            if (res.status == 200 && res.data.hasOwnProperty('success') && res.data.picture_path != '') {
                dispatch(saveResume(
                    {
                        heading: {
                            ...resume.heading,
                            profile_picture: {
                                picture_path: res.data.picture_path,
                                picture_abs_path: res.data.picture_abs_path
                            }
                        }
                    },
                    PREVIEW_RESUME, false))
                return res.data.image_name;
            }
        }).then((resp => {
            return { msg: 'success', name: resp }
        })).catch((e) => {
            throw (e)
        })
    }
}

export const uploadTopResumeFile = (fileupload) => {
    return function (dispatch, getState) {
        console.log('Resume File upload started..!!')
        return WpAPI.uploadTopResumeFile(fileupload).then((res) => {
            //const { resume } = getState();
            if (res.status == 200 && res.data.hasOwnProperty('success') && res.data.topresume_path != '') {
                return res.data;
            }
        }).then((resp => {
            return { msg: 'success', data: resp }
        })).catch((e) => {
            throw (e)
        })
    }
}

export const submitFormData = (fdata) => {
    return function (dispatch, getState) {
        console.log('Form Submission started..!!')
        return WpAPI.submitTopResumeData(fdata).then((res) => {
            //const { resume } = getState();
            if (res.status == 200) {
                return res.data;
            }
        }).then((resp => {
            return { msg: 'success', data: resp }
        })).catch((e) => {
            throw (e)
        })
    }
}

export const createNewResume = () => {
    return function (dispatch, getState) {
        const c = localStorage.getItem('selected_color')
        const t = localStorage.getItem('selected_template')
        const cc = localStorage.getItem('selected_custom_color')
        Cookies.remove('current_resume', { domain: COOKIE_DOMAIN, path: "/" })
        try {
            WpAPI.fetchActiveResume(dispatch, ()=>{
                dispatch(saveResume(
                    {
                        active_color: c ? c : 'color-variant-blue',
                        active_template: t ? t : 'template-one',
                        custom_template_color: cc ?? '',
                        summary: {content: ''},
                        created_date: getDateTime(),
                        modified_date: getDateTime()
                    },
                    PREVIEW_RESUME,
                    true))
            })
        } catch (error) {
            console.error("Caught an error when fetching active resumes:", error);
        }
        localStorage.removeItem('selected_color')
        localStorage.removeItem('selected_template')
        localStorage.removeItem('selected_custom_color')
    }
}

export const createNewResume4rmShowcase = (showcase) => {
    return function (dispatch, getState) {
        Cookies.remove('current_resume', { domain: COOKIE_DOMAIN, path: "/" })
        WpAPI.fetchActiveResume(dispatch, ()=>{
            dispatch(saveResume(
                {
                    ...showcase,
                    created_date: getDateTime(),
                    modified_date: getDateTime()
                },
                PREVIEW_RESUME,
                true))
        })
        // localStorage.removeItem('selected_color')
        // localStorage.removeItem('selected_template')
        // localStorage.removeItem('selected_custom_color')
    }
}

export const updateEditor = (editorType) => {
    return function (dispatch, getState) {
        WpAPI.fetchActiveResume(dispatch, () => {
            let obj = {
                active_editor: editorType ?? 'traditional',
            }
            dispatch(saveResume(
                    obj,
                    PREVIEW_RESUME,
                    true
                )
            )
        })
    }
}

export const updateTemplate = (customColor, color, tpl) => {
    return function (dispatch, getState) {
        let obj = {
            active_color: color ? color : 'color-variant-blue',
            active_template: tpl ? tpl : 'template-one',
            custom_template_color: customColor ? customColor : ''
        }
       
        if(getState().resume.created_date == '')
        {
            WpAPI.fetchActiveResume(dispatch, ()=>{
            let obj = {
                active_color: color ? color : 'color-variant-blue',
                active_template: tpl ? tpl : 'template-one',
                custom_template_color: customColor ? customColor : ''
            }
            // If resume starts from choose-template page then initialize created_date.
                obj = getState().resume.created_date != '' ? { ...getState().resume, ...obj, modified_date: getDateTime() } : { ...obj, created_date: getDateTime() };

            dispatch(saveResume(
                obj,
                PREVIEW_RESUME,
                true))
        })}else{
        dispatch(saveResume(
            { ...getState().resume, ...obj},
            PREVIEW_RESUME,
            true))
        }
    }
}

export const withoutMerge = (resume => {
    return ({
        type: WITHOUT_MERGE,
        payload: resume
    });
})

export const deleteSection = (name) => {
    return function (dispatch, getState) {
        let resume = { ...getState().resume }
        delete resume[name]
        dispatch(withoutMerge(resume))
    }
}

export const loadResume = (id) => {
    return function (dispatch, getState) {
        return new Promise((resolve, reject) => {
            Cookies.set('current_resume', id, { domain: COOKIE_DOMAIN, path: '/' })
            WpAPI.fetchActiveResume(dispatch, () => {
                const s = getState()
                resolve(s)
            })
        }).then((r) => {

            return { msg: 'success', ...r }
        }).catch((e) => {
            throw (e)
        })

    }
}

export const loadLetter = (id) => {
    return async function (dispatch, getState) {
        try {
            const r = await new Promise((resolve, reject) => {
                Cookies.set('current_letter', id, { domain: COOKIE_DOMAIN, path: '/' });
                WpAPI.fetchActiveLetter(dispatch, () => {
                    const s = getState();
                    resolve(s);
                });
            });
            return { msg: 'success', ...r };
        } catch (e) {
            throw (e);
        }

    }
}

export const generateEntityLink = (data, user_id, type, entity = {type: 'resume', name: 'Resume'}) => {
    return function (dispatch, getState) {
        const f1 = entity.type == 'resume' ? 'generateResumeLink' :  'generateLetterLink'
        const linkfield =  entity.type == 'resume' ? 'resume_link' :  'cover_link'
        return new Promise((resolve, reject) => {
            WpAPI[f1]( data.id, user_id).then((res, error) => {
                if(res?.link){
                    //Commented this, let link be generated everytime
                    // if(type == 'currentResume'){
                    //     dispatch(saveResume(
                    //         {...data, [linkfield]: res.link},
                    //         PREVIEW_RESUME,
                    //         true
                    //     ))
                    // }else{
                        // dispatch(loadResume(data.id)).then(resp => {
                        // dispatch(
                        //     saveResume(
                        //         {...resp[entity.name], [linkfield]: res.link},
                        //         PREVIEW_RESUME,
                        //         true
                        //     ))
                        // })
                    // }
                    resolve(res)
                }else{
                    reject(error)
                }
            }).catch((e) => {
                console.log(e)
            })
        }).catch((e) => {
            console.log(e)
        })
    }
}

export const duplicateResume = (resume_id, resume_name = '', type = 'list') => {
    const loginHash = Cookies.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"});
    return function (dispatch, getState) {
        return new Promise((resolve, reject) => {
            WpAPI.duplicateResume(resume_id, resume_name).then( res => {
                // dispatch(saveResume(
                //     res.resume,
                //     PREVIEW_RESUME,
                //     true))
                if(type == 'currentResume'){
                    delete res.resume.resume_name;
                    dispatch(saveResume(
                        res.resume,
                        PREVIEW_RESUME,
                        true,
                        false
                    ))
                }else{
                    dispatch(loadResume(res.currentResume)).then(resp => {
                        dispatch(
                            saveResume(
                                resp.resume,
                                PREVIEW_RESUME,
                                true,
                                false
                            )
                        )
                    })
                    dispatch(setInitialData(loginHash ? loginHash : null, res.currentResume, res.resume))
                }
                resolve(res.resumes);
            })
        })
    }
}

export const duplicateLetter = (letter_id, letter_name = '', type = 'list') => {
    const loginHash = Cookies.get('rbuser', { domain: COOKIE_DOMAIN, path: "/" });
    return function (dispatch, getState) {
        return new Promise((resolve, reject) => {
            // if (letter_id == null) {
            //     const newId = uuidv4();
            //     WpAPI.saveCoverLetter(getState(), true, newId)
            //     resolve('completed')
            // } else {
                WpAPI.duplicateLetterInLocalStorage(letter_id, letter_name).then(res => {
                    
                    WpAPI.saveCoverLetter({coverletter: res.letter, loginHash: getState().loginHash}, true, res.new_id);

                    // dispatch(loadLetter(res.currentLetter)).then(resp => {
                    //     dispatch(
                    //         saveCoverLetter(
                    //             resp.letter,
                    //             true
                    //         )
                    //     )
                    // })
                    // dispatch(initializeCoverletter(loginHash ? loginHash : null, res.currentLetter, res.letter))
                    resolve(type == 'list' ? res.letters :  'completed' );
                })
            // }
        })
    }
}

export const setVersion = (resume) => {
    return {
      type: STORE_VERSION,
      resume: resume
    }
}

export const AISearchResponse = (section, phrase) => {
    return function (dispatch, getState) {
        return new Promise((resolve, reject) => {
            WpAPI.getPhraseDataByAI(section, phrase).then( (res, error) => {
                if(res.status === 'ok'){
                    dispatch({
                        type: UPDATE_REDUCER,
                        payload: {aidata: res.output}
                    })
                    resolve({status: "ok", aidata: res.output})
                }else{
                    reject({status: "error", error: error})
                }
            })
        }).catch(e => {
            reject({status: "error", error: error})
        })
    }
}

export const updateAISearchResponse = (aidata) => {
    return {
        type: UPDATE_REDUCER,
        payload: {aidata: aidata}
    }
}

export const setResumeFormat = (downloadFormat) => {
    return {
        type: SET_DOWNLOAD_FORMAT,
        downloadFormat: downloadFormat
    }
}

export const saveUser = (user) => {
    return {
        type: SET_USER_DATA,
        payload: user
    }
}

export const setMembershipData = (membership) => {
    return {
        type: SET_MEMBERSHIP_DATA,
        payload: membership
    }
}

export const userCompletesSectionsDownloadsPrintsOrShares = (resume, type) => {
    return function (dispatch, getState) {
        return new Promise((resolve, reject) => {
            WpAPI.userCompletesSectionsDownloadsPrintsOrShares(resume).then( res => {
                if(res.completed){
                    if(type == 'currentResume'){
                        dispatch(saveResume(
                            {...resume, user_completes_sections_downloads_prints_or_shares: res.completed},
                            PREVIEW_RESUME,
                            true
                        ))
                    }else{
                        dispatch(loadResume(resume.id)).then(resp => {
                        dispatch(
                            saveResume(
                                {...resp.resume, user_completes_sections_downloads_prints_or_shares: res.completed},
                                PREVIEW_RESUME,
                                true
                            ))
                        })
                    }
                }
                resolve({completed: res.completed});
            })
        })
    }
}

export const setContextMenu = (contextMenu) => {
    return {
        type: SET_CONTEXT_MENU,
        payload: contextMenu
    }
}
export const loadCoverletterQA = () =>{
    return function (dispatch, getState) {
    const obj = JSON.parse(localStorage.getItem('clobj'))
        if(!getState().coverletter.qa_steps_initiated && obj){
        // if(obj){
            dispatch(
                ({
                    type: COVERLETTER_UPDATE,
                    payload: {...obj}
                }))
        }
    }
}
export const initiateCoverLetterQA = (customColor, color, tpl, exp = null) => {
    return function (dispatch, getState) {
        let obj = {
            active_color: color ? color : '',
            active_template: tpl ? tpl : 'template-eleven',
            custom_template_color: customColor ? customColor : '',
            qa_steps_initiated: true
        }
        obj = { ...initialData.coverletter, ...obj };
        obj.ques_ans_response.experience = exp;
        
        Promise.resolve(dispatch(
            ({
                type: COVERLETTER_UPDATE,
                payload: {...obj}
            })
        )).then(() => {
            localStorage.setItem('clobj', JSON.stringify(getState().coverletter));
            localStorage.removeItem('cl_color')
            localStorage.removeItem('cl_tpl')
            localStorage.removeItem('cl_custom_color')
            localStorage.removeItem('cl_builder')
        })
    }
}
export const createCoverLetter = () => {
    return function (dispatch, getState) {
        WpAPI.fetchActiveLetter(dispatch, () => {
            const obj = JSON.parse(localStorage.getItem('clobj'))
            dispatch(saveCoverLetter(obj, true))
            localStorage.removeItem('clobj')
        })
    }
}
export const saveCoverLetterQA = (obj) => {
    return function (dispatch, getState) {
        Promise.resolve(dispatch(
            ({
                type: COVERLETTER_UPDATE,
                payload: {...obj}
            })
        )).then(() => {
            localStorage.setItem('clobj', JSON.stringify( getState().coverletter));
        })
    };
}
export const updateCoverLetterTemplate = (customColor, color, tpl, exp = null) => {
    return function (dispatch, getState) {
        let obj = {
            active_color: color ? color : 'color-variant-blue',
            active_template: tpl ? tpl : 'template-one',
            custom_template_color: customColor ? customColor : ''
        }
        dispatch(saveCoverLetter(
            { ...getState().coverletter, ...obj},
            true))
        }
}
export const initializeCoverletter = (loginHash, currentletter, coverletter, user) => {
    const action_data = {
        type: INITIALIZE_COVER_LETTER,
    }
    if (loginHash) action_data['loginHash'] = loginHash
    if (currentletter) action_data['currentLetter'] = currentletter
    if (coverletter) action_data['coverletter'] = coverletter
    if (user) action_data['user'] = user
    return action_data;

}

export const updateFinalTargetLink = (data) => {
    return {
        type: UPDATE_REDUCER,
        payload: {redirect_to: data.link}
    }
}

export const updateUser = (user) => {
    return {
        type: UPDATE_REDUCER,
        payload: {user: user}
    }
}

export const updateProfilePictureStatus = (tpl) => {
    const activeTemplate = TPLTS.find(t => t?.resume && t.id === tpl);
    return {
        type: UPDATE_REDUCER,
        payload: {has_profile_picture: activeTemplate?.profile_picture || false}
    }
}